import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetLaundryWithChangesCountRes } from "types/laundry"

import laundriesService from "api/laundriesService"

const useGetLaundryWithChangesCount = (enabled: boolean) => {
  return useQuery("laundry_changes_count", async () => {
    try {
      const res: AxiosResponse<IGetLaundryWithChangesCountRes> = await laundriesService.getLaundryWithChangesCount()

      return res.data
    } catch(err: any) {
      return err.response
    }
  }, { enabled, refetchOnWindowFocus: false })
}

export default useGetLaundryWithChangesCount